/*quantity move*/
document.addEventListener('DOMContentLoaded', function() {
  const productInfo = document.querySelector('.joe-product__info-container');
  
  if (!productInfo) return;
  
  const sectionId = productInfo.getAttribute('data-section-id');
  const quantityForm = productInfo.querySelector(`#Quantity-Form-${sectionId}`);
  const addFrom = productInfo.querySelector(`div.joe-product-submit_container`);
  const addCart = productInfo.querySelector(`#ProductSubmitButton-${sectionId}`);
  
  // 先执行数量选择器的移动
  if (quantityForm && addFrom && addCart) {
    addFrom.insertBefore(quantityForm, addCart);
  }

  const container = productInfo.querySelector(`shopify-accelerated-checkout`);
  if (!container) return;
  // 创建 MutationObserver 监听支付选项元素的加载
  const observer = new MutationObserver((mutations, obs) => {
    const moreOptions = productInfo.querySelector('more-payment-options-link');
    const payments = productInfo.querySelector('div.product-form__buttons div.joe-footer__payment');
    const paymentButton = productInfo.querySelector('a.shopify-payment-button__more-options');
    //paymentButton.textContent = '';
   if (moreOptions && payments && paymentButton) {
      // 找到目标元素后，执行移动操作
     /*  moreOptions.insertBefore(payments, paymentButton.nextSibling);*/
      // 完成操作后停止观察
      obs.disconnect();
    }
  });
  
  // 配置观察器选项
  const config = {
    childList: true,     // 监听子元素变化
    subtree: true,       // 监听所有后代元素
    attributes: false    // 不监听属性变化
  };
  
  // 开始观察
  observer.observe(container, config);
  
  // 设置超时保护，防止无限等待
  setTimeout(() => {
    observer.disconnect();
  }, 10000); // 10秒后停止观察
});



